module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader-container"
  }, [(_vm.label) ? _c('label', {
    staticClass: "uploader-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('el-upload', {
    ref: "upload",
    staticClass: "uploader",
    attrs: {
      "action": ((_vm.$config.DOMAIN) + "admin/" + _vm.mediaType + "s"),
      "headers": _vm.$store.getters.httpAdminHeaderUploader,
      "data": _vm.otherData,
      "name": _vm.mediaType,
      "multiple": false,
      "accept": _vm.option.accept,
      "file-list": _vm.fileList,
      "show-file-list": _vm.showList,
      "list-type": _vm.listType,
      "auto-upload": _vm.autoUpload,
      "on-error": _vm.onError,
      "onProgress": _vm.onProgress,
      "on-success": _vm.onSuccess,
      "on-change": _vm.onChange,
      "before-upload": _vm.beforeFileUpload,
      "disabled": _vm.disabled
    }
  }, [_c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.placeholder || _vm.option.tips))]), _c('el-button', {
    staticClass: "todoBtn",
    attrs: {
      "slot": "trigger",
      "type": "success",
      "size": "small",
      "icon": "el-icon-upload2",
      "disabled": _vm.disabled
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.option.text))]), (_vm.showDoc && !!_vm.formatIcon(_vm.docType)) ? _c('div', {
    staticClass: "ed-videoPlayer"
  }, [_c('img', {
    attrs: {
      "src": _vm.formatIcon(_vm.docType),
      "alt": ""
    }
  })]) : _vm._e(), (_vm.showServerFiles) ? _c('el-popover', {
    ref: "mediasPopover",
    staticClass: "media-library-btn",
    attrs: {
      "placement": "bottom-start",
      "width": "678",
      "trigger": "click"
    }
  }, [(_vm.medias.length > 0) ? _c('div', {
    staticClass: "medias"
  }, [_vm._l((_vm.medias), function(media) {
    return _c('img', {
      staticClass: "media-thumbnail",
      attrs: {
        "src": media.thumbnail
      },
      on: {
        "click": function($event) {
          return _vm.onSelectFile(media)
        }
      }
    })
  }), (_vm.currentPage < _vm.totalPages) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.$store.state.loading),
      expression: "$store.state.loading"
    }],
    staticClass: "more",
    on: {
      "click": _vm.getMoreMedias
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  })]) : _vm._e()], 2) : _c('div', {
    staticClass: "medias-none"
  }, [_vm._v("还没有上传过任何资源")]), _c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary",
      "icon": "el-icon-search"
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.option.selectText))])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa9b261","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uploader.vue
// module id = 569
// module chunks = 85